import { render, staticRenderFns } from "./RepetitionAudioSelectLessonDialog.vue?vue&type=template&id=554a560f&scoped=true&"
import script from "./RepetitionAudioSelectLessonDialog.vue?vue&type=script&lang=ts&"
export * from "./RepetitionAudioSelectLessonDialog.vue?vue&type=script&lang=ts&"
import style0 from "./RepetitionAudioSelectLessonDialog.vue?vue&type=style&index=0&id=554a560f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554a560f",
  null
  
)

export default component.exports